module.exports = __webpack_public_path__ + "media/images/weather-icons/fill/openweather-weathercodes/02n-4aca209bd8bd9e66fcecf700f6f89a39.svg";